import { observable, action } from 'mobx';
import { Objects } from 'api';

class ObjectsStore {
  @observable objects = [];

  @observable fetchState;

  anketId;

  @action.bound
  async getObjects(anketId) {
    if (this.anketId === anketId) {
      return;
    }

    this.fetchState = 'pending';

    try {
      const response = await Objects.getObjects(anketId);
      this.objects = response.data;
      this.fetchState = 'fulfilled';
      this.anketId = anketId;
    } catch (e) {
      this.fetchState = 'rejected';
    }
  }
}

const objectsStore = new ObjectsStore();

export default objectsStore;
